import axios from 'axios';

import { setAlert } from './alert';
import { changeLoader } from './loader';
import { PAGOS } from './types';

export const buscarPagos = (filtros = {}) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/pagos_vueltas/listar`, body, config);
        await dispatch({ type: PAGOS.BUSCAR, payload: res.data.pagos });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const informacionPago = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/pagos_vueltas/informacion`, body, config);
        await dispatch({ type: PAGOS.INFORMACION, payload: res.data.pago });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const limpiarPago = () => dispatch => {
    dispatch({ type: PAGOS.LIMPIAR });
};
